export class FormatUtils {
    
    static display_money(value) {
        var nf = new Intl.NumberFormat();
        return nf.format(value.toFixed(0)); // "1,234,567,890"
    }
}
